<div class="gallery-page">
  <div class="custom-container">
    <app-header-style-seven></app-header-style-seven>

    <section class="gallery-hero">
      <div class="gallery-hero__content">
        <span class="hero-kicker">Campus Life</span>
        <h1>Photo Gallery</h1>
        <p>
          Explore memorable moments, academic activities, celebrations, workshops,
          and campus events captured across the years.
        </p>
      </div>
    </section>

    <section *ngIf="marqueeList.length > 0" class="notice-strip">
      <div class="notice-label">Highlights</div>
      <div class="notice-content">
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span *ngFor="let text of marqueeList; let last = last">
            {{ text }}<span *ngIf="!last"> | </span>
          </span>
        </marquee>
      </div>
    </section>

    <section *ngIf="availableYears.length > 0" class="year-panel">
      <div class="section-head">
        <h2>Browse by Year</h2>
        <p>Select an academic year to view event-wise gallery collections.</p>
      </div>

      <div class="tabs-container">
        <button
          *ngFor="let year of availableYears"
          type="button"
          class="year-tab"
          [class.active]="selectedTab === year"
          (click)="selectTab(year)"
        >
          {{ year }}
        </button>
      </div>
    </section>

    <section class="gallery-content">
      <div *ngIf="groupedPhotos.length === 0" class="empty-state">
        <h3>No photos available</h3>
        <p>No gallery items were found for {{ selectedTab || 'the selected year' }}.</p>
      </div>

      <article *ngFor="let group of groupedPhotos" class="event-card">
        <div class="event-card__head">
          <div>
            <span class="event-kicker">Event Gallery</span>
            <h3 class="event-title">{{ group.event_title }}</h3>
            <p *ngIf="group.event_description" class="event-description">
              {{ group.event_description }}
            </p>
          </div>

          <div class="event-meta">
            {{ group.photos.length }} Photo{{ group.photos.length > 1 ? 's' : '' }}
          </div>
        </div>

        <div class="photo-grid">
          <button
            type="button"
            class="photo-card"
            *ngFor="let photo of group.photos; trackBy: trackByPhoto"
            (click)="openFullscreen(getImageUrl(photo.event_image))"
            [attr.aria-label]="'Open photo for ' + (photo.event_title || group.event_title)"
          >
            <img
              [src]="getImageUrl(photo.event_image)"
              [alt]="photo.event_title || group.event_title"
              loading="lazy"
            />
          </button>
        </div>
      </article>
    </section>

    <div
      *ngIf="fullscreenImage"
      class="fullscreen-overlay"
      (click)="closeFullscreen()"
    >
      <button
        type="button"
        class="close-btn"
        aria-label="Close image preview"
        (click)="closeFullscreen(); $event.stopPropagation()"
      >
        ×
      </button>

      <img
        [src]="fullscreenImage"
        alt="Fullscreen Photo"
        (click)="$event.stopPropagation()"
      />
    </div>
  </div>
</div>